import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';

addLocaleData(en);



// WEBPACK FOOTER //
// ./src/web/js/locale-data/en.js